import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["caption", "icon"];

var _class, _class2, _temp;

import React from 'react';
import PropTypes from 'prop-types';
import { filterProps } from "../../../lib/filterProps";
import { MenuHeader } from "../../MenuHeader";
import { MenuItem } from "../../MenuItem";
import { MenuSeparator } from "../../MenuSeparator";
import { Select } from "../../Select";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { rootNode } from "../../../lib/rootNode";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { getDropdownTheme } from "../getDropdownTheme";
var PASS_PROPS = {
  _renderButton: true,
  error: true,
  disabled: true,
  disablePortal: true,
  menuAlign: true,
  menuWidth: true,
  maxMenuHeight: true,
  use: true,
  size: true,
  warning: true,
  width: true,
  onOpen: true,
  onClose: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseOver: true,
  menuPos: true,
  id: true,
  'aria-describedby': true
};
export var DropdownDataTids = {
  root: 'Dropdown__root'
};
/**
 * Выпадающее меню.
 *
 */

export var Dropdown = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);

  function Dropdown() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderMain = function (_ref) {
      var caption = _ref.caption,
          icon = _ref.icon,
          props = _objectWithoutPropertiesLoose(_ref, _excluded);

      var items = React.Children.map(_this.props.children, function (item) {
        return item;
      }) || [];
      return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
        rootNodeRef: _this.setRootNode
      }, _this.props), /*#__PURE__*/React.createElement(Select, _extends({
        "data-tid": DropdownDataTids.root,
        ref: _this._refSelect
      }, filterProps(props, PASS_PROPS), {
        value: caption,
        items: items,
        _icon: icon,
        renderValue: renderValue,
        size: _this.props.size,
        "aria-label": _this.props['aria-label']
      })));
    };

    _this._refSelect = function (element) {
      _this._select = element;
    };

    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = getDropdownTheme(theme);
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: _this2.theme
      }, _this2.renderMain(_this2.props));
    });
  };
  /**
  * @public
  */


  _proto.open = function open() {
    if (this._select) {
      this._select.open();
    }
  }
  /**
  * @public
  */
  ;

  _proto.close = function close() {
    if (this._select) {
      this._select.close();
    }
  };

  return Dropdown;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Dropdown', _class2.displayName = 'Dropdown', _class2.Header = MenuHeader, _class2.MenuItem = MenuItem, _class2.Separator = MenuSeparator, _class2.propTypes = {
  /**
  * Подпись на кнопке.
  */
  caption: PropTypes.node.isRequired,

  /**
  * Отключает использование портала
  */
  disablePortal: PropTypes.bool,

  /**
  * Визуально отключает Dropdown
  */
  disabled: PropTypes.bool,

  /**
  * Визуально показать наличие ошибки.
  */
  error: PropTypes.bool,

  /**
  * Иконка слева от текста кнопки
  */
  icon: PropTypes.node,
  maxMenuHeight: PropTypes.number,
  menuAlign: PropTypes.oneOf(['left', 'right']),
  menuWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
  * Смотри Button.
  */
  use: PropTypes.any,

  /**
  * Визуально показать наличие предупреждения.
  */
  warning: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
  * Вызывается при закрытии меню.
  */
  onClose: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func,

  /**
  * Вызывается при открытии меню.
  */
  onOpen: PropTypes.func
}, _temp)) || _class;

function renderValue(value) {
  return value;
}